// extracted by mini-css-extract-plugin
export default {"wrapper":"NcM6fktjSON2ZzMioKra","title":"mMPvyNHGyyxBqNFOPZJs","solutions":"CVVeFhM7SeibCIZiOOoh","card":"_tqGf7yLZiZ8hbnHBj4A"};